import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  troncos: [],
  troncoSelecionado: {},
  troncoUse: {},
  rotasDisponiveis: [],
  gruposDeRotas: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
